// Copyright 2022, Imprivata, Inc.  All rights reserved.

import type { CodingContext } from '@imprivata-cloud/data-privacy-js';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { usePlatform } from '../../context/platform/hooks';
import { apiClient } from '../client';

const getPatientConsentConfigQueryKey = 'get-patient-consent-config';

export interface GetPatientConsentConfigResponse {
  documentId: string;
  documentUrl: string;
}

const getPatientConsentConfigQuery = async (
  codingContext: CodingContext | undefined,
): Promise<GetPatientConsentConfigResponse> => {
  return apiClient.get<GetPatientConsentConfigResponse>(
    'patientConsent/config',
    codingContext,
  );
};

export const useGetPatientConsentConfigQuery = () => {
  const { codingContext } = usePlatform();
  const [enabled, setEnabled] = useState<boolean>(false);
  const query = useQuery({
    queryKey: [getPatientConsentConfigQueryKey],
    queryFn: () => getPatientConsentConfigQuery(codingContext),
    enabled: enabled,
    retry: false,
  });
  return {
    config: query.data,
    isLoading: query.isLoading,
    isSuccess: query.isSuccess,
    isError: query.isError,
    setEnabled: () => setEnabled(true),
  };
};
